const LoadingBar = () => {
  return (
    <div className="relative h-1 w-full animate-bounce-horizontal overflow-hidden bg-th-bkg-2 sm:h-0.5">
      <div className="absolute h-1 w-24 bg-th-button sm:h-0.5" />
    </div>
  )
}

export default LoadingBar
